import type {
    GetParticipantsForAdminResponseType,
    GetParticipantsForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const threeTGetParticipantsForAdmin = async (args: GetParticipantsForAdminRequestType): Promise<GetParticipantsForAdminResponseType> => {
    return await request<GetParticipantsForAdminResponseType>(`/threeT/getParticipantsForAdmin?eventID=${args.eventID}&eventSubID=${args.eventSubID}`, {
        method: "GET"
    });
};

export default threeTGetParticipantsForAdmin;
